import React, {Component} from 'react';
/* Fusioncharts react wrapper and charts*/
import FusionCharts from 'fusioncharts/core';
import Column2D from 'fusioncharts/viz/column2d';
import Bar2D from 'fusioncharts/viz/bar2d';
import Doughnut2d from 'fusioncharts/viz/doughnut2d';
import Sparkline from 'fusioncharts/viz/sparkline';
import SparkColumn from 'fusioncharts/viz/sparkcolumn';
import Hbullet from 'fusioncharts/viz/hbullet';
import ReactFC from 'react-fusioncharts';
/* Util functions */
import {chartConfigGenerator,shipmentCountGenerator,billAmountGenerator,deliveryDelayGenerator,billRateGenerator,totalShipmentText,billAmountText,avgBillRateText,KpiLoader,KpiLoaderSecond} from '../util/index';

ReactFC.fcRoot(FusionCharts, Column2D, Doughnut2d, Sparkline, SparkColumn, Bar2D, Hbullet);

export default class KpiContainer extends Component {
    render () {
      var {data, timeSelectorValue, allShipperData} = this.props,
      value= avgBillRateText(data, allShipperData);

        return (
            <div className="row m-auto kpi-container">
                <div className="col-12 col-sm-6 col-lg-3  kpi-wrapper">
                    <div className="kpi" id="kpi1"><p className="kpi-header">Total Shipment Count</p><div className="kpi-data">{totalShipmentText(data, timeSelectorValue)}</div>{(data.length) ? <ReactFC {...chartConfigGenerator({type: 'sparkline', height: '50%', width: '98%',dataSource: shipmentCountGenerator, data: data, timeSelectorValue: timeSelectorValue })}/> : <KpiLoader /> }</div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3  kpi-wrapper">
                    <div className="kpi" id="kpi2"><p className="kpi-header">Total Bill Amount</p><div className="kpi-data">{billAmountText(data, timeSelectorValue)}</div>{(data.length) ? <ReactFC {...chartConfigGenerator({type: 'sparkcolumn', height: '50%',  width: '98%',dataSource: billAmountGenerator, data: data, timeSelectorValue: timeSelectorValue})} /> : <KpiLoader />}</div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3  kpi-wrapper">
                    <div className="kpi" id="kpi3"><p className="kpi-header">On Time Delivery</p>{(data.length) ? <ReactFC {...chartConfigGenerator({type: 'doughnut2d', height: '70%', width: '98%',dataSource: deliveryDelayGenerator, data: data, timeSelectorValue: timeSelectorValue})} /> : <KpiLoader />}</div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3  kpi-wrapper">
                    <div className="kpi" id="kpi4"><p className="kpi-header">Average Bill Rate Per Mile</p><div className="kpi-data-four">{value[0]}</div><div className={(value[2]==='+') ? 'kpi-small red-text' : 'kpi-small green-text'}>{value[1]}</div>{(data.length !== 0) ? <ReactFC {...chartConfigGenerator({type: 'hbullet', height: '40%', width: '98%', dataSource: billRateGenerator, data: data, timeSelectorValue: timeSelectorValue, allShipperData: allShipperData})}/> : <KpiLoaderSecond />}</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/KpiContainer.js